import React from 'react';
import { BrowserRouter as ReactRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import axios from 'axios';
import { ToastContainer } from 'react-toastify';

import PrivateRoute from '../components/PrivateRoute';
import { setUsuario } from '../actions/UsuarioActions';
import Login from '../views/Login';
import Usuarios from '../views/Usuarios';
import Contratos from '../views/Contratos';
import Produtos from '../views/Produtos';
import Videos from '../views/Videos';
import NotFound from '../views/NotFound';
import NoAccess from '../views/NoAccess';
import Dashboard from '../views/Dashboard';
import Publicacao from '../views/Publicacao';
import CadastrarPublicacao from '../views/CadastrarPublicacao';
import Publicacoes from '../views/Publicacoes';
import Publicacoes2 from '../views/Publicacoes2';
import PesquisaSatisfacao from '../views/PesquisaSatisfacao';
import FecharPublicacao from '../views/FecharPublicacao';
import ContratosInfo from '../views/ContratosInfo';
import UploadFotos from '../views/UploadFotos';
import ContratoPublicacao from '../views/ContratoPublicacao';
import UltimasPaginasPublicacao from '../views/UltimasPaginasPublicacao';
import DashboardProcedimentos from '../views/DashboardProcedimentos';
import EmailsAutomaticos from '../views/EmailsAutomaticos';
import AcessosPortal from '../views/AcessosPortal';
import BuscaCadastro from '../views/BuscaCadastro';

class Router extends React.Component {

  componentWillMount(){
    let usuario = JSON.parse(localStorage.getItem('usuarioLogadoAdministracao')),
      token = localStorage.getItem('token');

    if (usuario) {
      this.props.setUsuario(usuario);
    }

    if (token) {
      axios.defaults.headers.common['Authorization'] = token;
    }
  }

  render () {
    return (
      <ReactRouter>
        <div>
          <ToastContainer />
          <Switch>
            <Route exact path="/login" component={Login} />
            <PrivateRoute exact path="/" component={Dashboard} title="" hideHeader />
            <PrivateRoute exact path="/procedimentos" component={DashboardProcedimentos} title="Procedimentos" />
            <PrivateRoute exact path="/usuarios" component={Usuarios} title="Usuários" />
            <PrivateRoute exact path="/contratos/:caminho" component={Contratos} title="Contrato" />
            <PrivateRoute exact path="/produtos" component={Produtos} title="Produtos" />
            <PrivateRoute exact path="/videos" component={Videos} title="Vídeos" />
            <PrivateRoute exact path="/publicacao" component={CadastrarPublicacao} title="Cadastrar Publicação" />
            <PrivateRoute exact path="/publicacoes" component={Publicacoes} title="Visualizar Publicações" />
            <PrivateRoute exact path="/pesquisa-satisfacao" component={PesquisaSatisfacao} title="Pesquisa de Satisfação" />
            <PrivateRoute exact path="/unauthorized" component={NoAccess} title="Sem permissão" />
            <PrivateRoute exact path="/contrato" component={Publicacoes2} title="Visualizar Contrato" />
            <PrivateRoute exact path="/fechar-publicacao" component={FecharPublicacao} title="Fechar Publicação" />
            <PrivateRoute exact path="/contrato/:id/:tipo" component={ContratoPublicacao}/>
            <PrivateRoute exact path="/contrato/last/:id/:tipo" component={UltimasPaginasPublicacao} title="Últimas Publicações"/>
            <PrivateRoute exact path="/contrato/info" component={ContratosInfo} title="Contratos"/>
            <PrivateRoute exact path="/publicacoes/:id" component={Publicacao} title="Correções" />
            <PrivateRoute exact path="/convite-online" component={UploadFotos} title="Convite on-line" />
            <PrivateRoute exact path="/emails-automaticos" component={EmailsAutomaticos} title="E-mails automáticos" />
            <PrivateRoute exact path="/acessos-portal" component={AcessosPortal} title="Acessos do portal" />
            <PrivateRoute exact path="/buscar-cadastro" component={BuscaCadastro} title="Buscar cadastro" />
            <PrivateRoute component={NotFound} title="Página não encontrada" />
          </Switch>
        </div>
      </ReactRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    carregando: state.usuario.carregando,
    erro: state.usuario.erro,
    caminho: state.caminho.atual
  };
}

export default connect(mapStateToProps, {setUsuario})(Router);



// WEBPACK FOOTER //
// ./src/config/Router.js